import React, {useEffect, useState} from 'react';
import {ButtonBase} from '@material-ui/core';
import Utils from "../../../helpers/Utils";

const KEYPAD_NUMBERS = [
    { number: '1', letters: '' },
    { number: '2', letters: 'ABC' },
    { number: '3', letters: 'DEF' },
    { number: '4', letters: 'GHI' },
    { number: '5', letters: 'JKL' },
    { number: '6', letters: 'MNO' },
    { number: '7', letters: 'PQRS' },
    { number: '8', letters: 'TUV' },
    { number: '9', letters: 'WXYZ' },
    { number: '*', letters: '' },
    { number: '0', letters: '+' },
    { number: '#', letters: '' },
];

const ALLOWED_KEYS = ['0','1','2','3','4','5','6','7','8','9','*','#'];

const SendDigitKeypad = ({ onKeypress }) => {
    const [number, setNumber] = useState("");

    useEffect(() => {
        const handleKeyDown = (e) => {
            const activeTag = document.activeElement.tagName.toLowerCase();
            if (activeTag === 'input' || activeTag === 'textarea') return;

            const key = e.key;
            if (ALLOWED_KEYS.includes(key)) {
                setNumber(prev => prev + key);
            } else if (key === 'Backspace') {
                setNumber(prev => prev.slice(0, -1));
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    const handleInput = (e) => {
        setNumber(e.target.value);
    };

    return (
        <>
            <div className='globalDialerKeypadTray'>
                <div className='dialNumberWrapper'>
                    <input
                        className='dialedNumber'
                        onChange={handleInput}
                        value={number}
                    />
                </div>
                <div className='globalDialerKeypad'>
                    {
                        KEYPAD_NUMBERS.map((item, index) => (
                            <ButtonBase
                                key={index}
                                className='keypadItem'
                                onClick={() => {
                                    setNumber((prevState)=>(prevState + item.number));
                                    onKeypress(item.number);
                                }}
                            >
                                <div className='keypadNumber'>{item.number}</div>
                                {item.letters && <div className='keypadLetters'>{item.letters}</div>}
                            </ButtonBase>
                        ))
                    }
                </div>
            </div>
        </>
    );
};

export default SendDigitKeypad;